<ng-container matColumnDef [sticky]="sticky" [stickyEnd]="stickyEnd">
  <mat-header-cell *matHeaderCellDef>
    <ng-content [linConnectControl]="control"></ng-content>
  </mat-header-cell>
</ng-container>
